module.exports = __webpack_public_path__ + "img/cooperative0_logo3.fbbf3a72.jpg";